import { defineMeta } from '@/registry/types';

export const stepperMeta = defineMeta({
  name: 'Stepper',
  level: 'organism',
  category: 'navigation',
  classification: 'themed-mui',
  description: 'Shows progress through a sequential multi-step process. Themed MUI Stepper.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Stepper',
  muiDocs: 'https://mui.com/material-ui/react-stepper/',
  a2uiEquivalent: 'Stepper / Wizard',
  importPath: '@/organisms/Stepper',
  requiredProps: ['activeStep'],
  optionalProps: ['orientation', 'alternativeLabel', 'nonLinear'],
  supportedStates: ['active', 'completed', 'disabled', 'error'],
  designTokens: ['colors', 'typography'],
  accessibility: ['Convey current step; ensure step labels are descriptive.'],
  usageExamples: ['<Stepper activeStep={1}><Step><StepLabel>...</StepLabel></Step></Stepper>'],
  antiPatterns: ['Do not use for peer views (use Tabs).'],
  llmSafe: true,
  whenToUse: ['Wizards, onboarding, multi-step forms'],
  whenNotToUse: ['Non-sequential navigation'],
});

export default stepperMeta;
